"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ErrorScreen = void 0;
var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _react = _interopRequireDefault(require("react"));
var _AddChildPropsContext = require("../utils/_AddChildPropsContext");
var _useWindowSize = _interopRequireDefault(require("../utils/useWindowSize"));
var _useResizeObserver2 = _interopRequireDefault(require("../utils/useResizeObserver"));
var _Illustration = _interopRequireDefault(require("./_Illustration"));
var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof _getOwnPropertySymbols.default === "function") for (var i = 0, p = (0, _getOwnPropertySymbols.default)(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
// ⚠️ THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
var DialogErrorScreen = function DialogErrorScreen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M78.698 155.492a77.533 77.533 0 0 0 54.034-21.831H24.663a77.522 77.522 0 0 0 54.035 21.831ZM47.38 120.773h-.169a2.039 2.039 0 0 1-1.99-1.615L38.616 87.99l-22.125.352a.773.773 0 0 1-.786-.754L14.54 40.195a.768.768 0 0 1 .783-.793h1.379v-.705a.772.772 0 0 1 .787-.783l33.288.395a.766.766 0 0 1 .766.74l.575 23.32h70.035a2.031 2.031 0 0 1 1.996 1.646l10.523 54.335a2.04 2.04 0 0 1-.429 1.683 2.028 2.028 0 0 1-1.571.74h10.808a77.355 77.355 0 0 0 12.995-43.02C156.475 34.81 121.652 0 78.698 0 35.743 0 .906 34.8.906 77.742a77.381 77.381 0 0 0 14.141 44.709h30.337a2.036 2.036 0 0 1 1.996-1.678Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M112.375 114.676H52.898a2.027 2.027 0 0 1 0 0h59.477a2.034 2.034 0 0 0 0 0ZM46.273 87.873l1.915 10.402-1.915-10.402ZM89.428 74.636l16.057.056-16.057-.056-37.031-.127 37.031.127Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M75.79 125.755H47.38a2.045 2.045 0 0 1-1.44-.597 2.032 2.032 0 0 1-.595-1.441v-.91c0-.118.01-.236.032-.352H15.04a78.184 78.184 0 0 0 9.606 11.21h108.086a78.755 78.755 0 0 0 7.157-7.91H75.791Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.617 86.036a.77.77 0 0 1-.786-.744L16.7 39.419h-1.378a.769.769 0 0 0-.784.794l1.165 47.392a.772.772 0 0 0 .786.755l22.125-.353-.48-2.26-19.518.289Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M18.617 86.036a.77.77 0 0 1-.786-.744L16.7 39.419h-1.378a.769.769 0 0 0-.784.794l1.165 47.392a.772.772 0 0 0 .786.755l22.125-.353-.48-2.26-19.518.289Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m18.617 86.036 19.518-.307-1.058-5.074-14.273.215a.61.61 0 0 1-.603-.606l-.928-37.773h-.056v-.875h.5a.566.566 0 0 1 .139 0l1.57.022 24.487.077.547 20.67h3.647l-.582-23.318a.765.765 0 0 0-.765-.74l-33.275-.413a.773.773 0 0 0-.787.783v.705l1.13 45.883a.77.77 0 0 0 .79.751ZM44.248 76.885l.674 3.654-.674-3.654ZM48.012 74.495l-1.757-.007 1.757.007Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m21.256 42.49.928 37.774a.61.61 0 0 0 .603.606l14.272-.215-1.584-7.514a.73.73 0 0 1-.285-.59c0-.243-.032-.578-.06-1.057l-.064-.293a3.378 3.378 0 0 1-1.41.321c-3.154 0-5.708-3.621-5.708-8.089 0-1.837-.046-3.526.314-4.89-1.115.31-2.184-.022-2.438-.78-.187-.568.134-1.217.755-1.686h-.748a.79.79 0 0 1-.79-.79 2.528 2.528 0 0 1 2.533-2.531h1.41a4.4 4.4 0 0 1 3.317-1.971l2.448-.201a7.431 7.431 0 0 1 7.813 5.546 7.422 7.422 0 0 1 .064 3.438l-.536 2.786h5.573l-.579-19.567-25.828-.296Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.849 41.599a.556.556 0 0 0-.138 0h1.707-1.57ZM23.418 41.62l23.878.352a.61.61 0 0 1 .586.607l.486 19.8h.085l-.547-20.671-24.488-.088Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m23.418 41.62 23.878.352a.61.61 0 0 1 .586.607l.486 19.8h.085l-.547-20.671-24.488-.088Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.718 41.616h-.5v.875h.056v-.258a.613.613 0 0 1 .444-.617Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "M21.718 41.616h-.5v.875h.056v-.258a.613.613 0 0 1 .444-.617Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m47.296 41.962-23.878-.353h-1.7a.614.614 0 0 0-.462.617v.258l25.818.31.578 19.567h.706l-.487-19.8a.61.61 0 0 0-.575-.6Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m47.296 41.962-23.878-.353h-1.7a.614.614 0 0 0-.462.617v.258l25.818.31.578 19.567h.706l-.487-19.8a.61.61 0 0 0-.575-.6Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m34.738 50.598-2.448.2a4.4 4.4 0 0 0-3.316 1.972h-1.41a2.53 2.53 0 0 0-2.534 2.532.79.79 0 0 0 .79.79h.748c-.62.468-.942 1.117-.755 1.685.255.758 1.323 1.09 2.438.78-.353 1.357-.314 3.053-.314 4.89 0 4.468 2.554 8.09 5.707 8.09.489-.005.97-.114 1.412-.322l-1.344-6.407a2.035 2.035 0 0 1 1.993-2.468h6.38l.537-2.786a7.424 7.424 0 0 0-4.489-8.445 7.431 7.431 0 0 0-3.395-.511Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m34.738 50.598-2.448.2a4.4 4.4 0 0 0-3.316 1.972h-1.41a2.53 2.53 0 0 0-2.534 2.532.79.79 0 0 0 .79.79h.748c-.62.468-.942 1.117-.755 1.685.255.758 1.323 1.09 2.438.78-.353 1.357-.314 3.053-.314 4.89 0 4.468 2.554 8.09 5.707 8.09.489-.005.97-.114 1.412-.322l-1.344-6.407a2.035 2.035 0 0 1 1.993-2.468h6.38l.537-2.786a7.424 7.424 0 0 0-4.489-8.445 7.431 7.431 0 0 0-3.395-.511ZM35.474 73.14l-.352-1.632c.029.466.05.8.06 1.058a.732.732 0 0 0 .292.575Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m35.474 73.14-.352-1.632c.029.466.05.8.06 1.058a.732.732 0 0 0 .292.575Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m134.672 118.35-10.523-54.335a2.031 2.031 0 0 0-1.996-1.647H35.697a2.036 2.036 0 0 0-1.992 2.468l1.354 6.393.064.293.352 1.633 1.591 7.514 1.058 5.074.48 2.26 6.607 31.169a2.036 2.036 0 0 0 1.99 1.615h85.471a2.03 2.03 0 0 0 1.578-.744 2.04 2.04 0 0 0 .422-1.693Zm-13.359-18.632h-9.323l2.388 12.532c.06.279.06.567 0 .846a2.034 2.034 0 0 1-1.975 1.566H52.898a2.024 2.024 0 0 1-1.926-1.411 1.565 1.565 0 0 1-.071-.254l-2.727-14.725-1.915-10.399-.416-2.264-.935-5.07-.674-3.654a2.02 2.02 0 0 1 0-.666 1.98 1.98 0 0 1 .321-.832 2.017 2.017 0 0 1 1.693-.9h6.145l37.039.128-.706-3.696a2.047 2.047 0 0 1 2.014-2.43h25.451a2.057 2.057 0 0 1 2.018 1.668l5.118 27.124a2.045 2.045 0 0 1-.434 1.692 2.042 2.042 0 0 1-1.58.745Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color2)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.38 120.773a2.034 2.034 0 0 0-2.035 2.031v.91a2.03 2.03 0 0 0 .595 1.441 2.049 2.049 0 0 0 1.44.597h28.41a3.286 3.286 0 0 1-2.687-1.411l-2.519-3.586H47.38v.018Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color13)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M160.906 120.773H70.584l2.52 3.586a3.286 3.286 0 0 0 2.687 1.41h83.347a1.764 1.764 0 0 0 1.764-1.763v-3.216l.004-.017ZM118.212 70.179a2.05 2.05 0 0 0-2.017-1.668H90.744a2.05 2.05 0 0 0-2.014 2.43l.705 3.695 16.057.056h.057a2.033 2.033 0 0 1 1.989 1.65l4.452 23.376h9.323a2.05 2.05 0 0 0 1.987-1.537c.076-.292.086-.596.031-.893l-5.119-27.11Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m82.317 95.162 2.723-2.983a1.264 1.264 0 0 0-.159-1.813 1.247 1.247 0 0 0-1.816 0l-2.724 2.98-3.241-2.98a1.248 1.248 0 0 0-1.817 0 1.263 1.263 0 0 0 .159 1.813l3.245 2.983-2.723 2.98a1.266 1.266 0 0 0 .159 1.816 1.263 1.263 0 0 0 .908.388 1.252 1.252 0 0 0 .908-.389l2.72-2.983 3.245 2.983a1.264 1.264 0 0 0 .908.389 1.252 1.252 0 0 0 .909-.389 1.265 1.265 0 0 0-.163-1.816l-3.241-2.98Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M79.156 80.006a13.663 13.663 0 0 0-10.23 4.376 13.75 13.75 0 0 0-3.467 10.646c.727 8.318 8.092 15.088 16.413 15.088a13.646 13.646 0 0 0 10.23-4.376 13.746 13.746 0 0 0 3.489-10.645c-.748-8.319-8.11-15.089-16.435-15.089Zm2.47 28.118c-7.133 0-13.48-5.832-14.11-12.962-.632-7.13 4.701-12.966 11.834-12.966s13.479 5.836 14.11 12.966c.632 7.13-4.691 12.962-11.824 12.962h-.01Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M107.531 76.342a2.028 2.028 0 0 0-1.989-1.65h-.057l-16.057-.056-37.038-.127h-6.145a2.01 2.01 0 0 0-1.693.9c-.17.248-.28.533-.322.831a2.02 2.02 0 0 0 0 .667l.674 3.653.935 5.07.416 2.264 1.92 10.378 2.712 14.739c.016.087.04.172.07.254a2.027 2.027 0 0 0 1.926 1.411h59.491a2.034 2.034 0 0 0 1.976-1.566 2.01 2.01 0 0 0 0-.846l-2.36-12.546-4.459-23.376ZM92.673 106.28a14.444 14.444 0 0 1-10.811 4.637c-8.727 0-16.449-7.098-17.21-15.822a14.552 14.552 0 0 1 3.696-11.245 14.442 14.442 0 0 1 10.808-4.637c8.727 0 16.449 7.098 17.214 15.822a14.548 14.548 0 0 1-3.697 11.245Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M79.368 82.196c-7.133 0-12.46 5.836-11.835 12.966.624 7.13 6.97 12.962 14.11 12.962s12.456-5.832 11.831-12.962c-.624-7.13-6.974-12.966-14.106-12.966Zm6.35 17.761a1.264 1.264 0 0 1-.91.389 1.252 1.252 0 0 1-.907-.389l-3.246-2.983-2.72 2.983a1.265 1.265 0 0 1-.908.389 1.252 1.252 0 0 1-.908-.389 1.265 1.265 0 0 1-.159-1.816l2.723-2.98-3.245-2.982a1.264 1.264 0 0 1-.159-1.813 1.249 1.249 0 0 1 1.817 0l3.242 2.98 2.723-2.98a1.249 1.249 0 0 1 1.817 0 1.265 1.265 0 0 1 .407 1.374c-.052.162-.137.31-.249.439l-2.723 2.983 3.242 2.98a1.266 1.266 0 0 1 .166 1.816h-.004Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color11)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M79.156 79.206a14.445 14.445 0 0 0-10.808 4.644 14.555 14.555 0 0 0-3.697 11.252c.762 8.724 8.466 15.822 17.21 15.822a14.442 14.442 0 0 0 10.812-4.637 14.557 14.557 0 0 0 3.697-11.252c-.765-8.717-8.487-15.83-17.214-15.83Zm12.928 26.534a13.65 13.65 0 0 1-10.23 4.376c-8.32 0-15.686-6.77-16.413-15.088a13.748 13.748 0 0 1 3.489-10.646 13.66 13.66 0 0 1 10.23-4.376c8.325 0 15.686 6.77 16.416 15.089a13.747 13.747 0 0 1-3.492 10.645Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }));
};
DialogErrorScreen.defaultProps = {
  width: "161",
  height: "156",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Dialog-ErrorScreen"
};
var DotErrorScreen = function DotErrorScreen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "M10.642 7.624 5.547 38.337a2.365 2.365 0 0 0 1.946 2.72l21.432 3.556a2.365 2.365 0 0 0 2.72-1.946l5.096-30.713a2.365 2.365 0 0 0-1.946-2.72L13.362 5.678a2.365 2.365 0 0 0-2.72 1.946Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.493 7.127H7.59A2.322 2.322 0 0 0 5.27 9.448V39.43a2.322 2.322 0 0 0 2.321 2.322h20.903a2.322 2.322 0 0 0 2.322-2.322V9.45a2.322 2.322 0 0 0-2.322-2.322Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M28.328 42.071H7.79A2.798 2.798 0 0 1 5 39.281V9.614a2.798 2.798 0 0 1 2.79-2.79h20.582a2.789 2.789 0 0 1 2.789 2.79v29.669a2.79 2.79 0 0 1-2.833 2.79ZM7.79 7.491a2.166 2.166 0 0 0-2.165 2.165v29.626a2.166 2.166 0 0 0 2.165 2.166h20.583a2.174 2.174 0 0 0 2.174-2.166V9.612a2.174 2.174 0 0 0-2.174-2.165L7.789 7.49Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color4)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.546 15.573a6.263 6.263 0 1 0 0-12.526 6.263 6.263 0 0 0 0 12.526Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.806 2.905a6.084 6.084 0 1 0 0 12.168 6.084 6.084 0 0 0 0-12.168Zm-8.989 6.084a8.989 8.989 0 1 1 17.978 0 8.989 8.989 0 0 1-17.978 0Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M30.814 1.427a7.545 7.545 0 1 0 7.537 7.545 7.57 7.57 0 0 0-7.537-7.545Zm2.79 9.277a.747.747 0 1 1-1.057 1.057l-1.732-1.732-1.733 1.732a.744.744 0 1 1-1.048-1.057l1.732-1.732-1.732-1.733a.745.745 0 0 1 1.048-1.048l1.732 1.733 1.733-1.733a.745.745 0 0 1 1.057 1.048L31.87 8.972l1.733 1.732Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color11)"
    }
  }));
};
DotErrorScreen.defaultProps = {
  width: "45",
  height: "45",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Dot-ErrorScreen"
};
var SceneErrorScreen = function SceneErrorScreen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m176.854 126.17-19.61-.066-45.569-.159 45.569.159 19.61.066Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M305.502.005H180.443v9.222a6.617 6.617 0 0 1-1.945 4.674 6.648 6.648 0 0 1-4.686 1.94h-44.3a6.65 6.65 0 0 1-4.686-1.94 6.612 6.612 0 0 1-1.944-4.674V.005H39.644v49.362a6.61 6.61 0 0 1-1.944 4.675 6.644 6.644 0 0 1-4.687 1.939H0v129.068a14.377 14.377 0 0 0 4.231 10.19 14.449 14.449 0 0 0 10.216 4.221h15.989a4.513 4.513 0 0 1-.47-1.966v-6.286a4.47 4.47 0 0 1 1.314-3.164 4.494 4.494 0 0 1 3.172-1.311h69.365a2.43 2.43 0 0 1-.231-1.027v-1.107a2.472 2.472 0 0 1 2.479-2.472h-.207a2.48 2.48 0 0 1-1.56-.552 2.466 2.466 0 0 1-.862-1.409l-8.564-40.313-32.274.497a1.06 1.06 0 0 1-1.073-1.027l-1.584-64.429a1.049 1.049 0 0 1 1.067-1.079h1.881v-.966a1.039 1.039 0 0 1 .656-.986c.131-.052.271-.077.412-.074l45.353.535a1.042 1.042 0 0 1 1.044 1.008l.94 37.846h85.796a2.47 2.47 0 0 1 2.436 2.003l12.801 65.981a2.472 2.472 0 0 1-2.431 2.942h34.358v3.907a2.197 2.197 0 0 1-.127.699h65.179c1.749 0 3.17 2.003 3.17 4.475v6.478a14.417 14.417 0 0 0 5.5-5.289 14.374 14.374 0 0 0 2.024-7.348V14.416a14.404 14.404 0 0 0-4.25-10.208A14.48 14.48 0 0 0 305.502.005V.004Zm-8.625 73.646a.995.995 0 0 1-.634.92 1.002 1.002 0 0 1-.387.07h-1.829v1.937a.995.995 0 0 1-.299.717 1.016 1.016 0 0 1-.721.292l-43.444-.394a1.013 1.013 0 0 1-1.002-1.009V14.415a1.012 1.012 0 0 1 1.049-1.008l1.801.065v-.938a1.013 1.013 0 0 1 .313-.72 1.004 1.004 0 0 1 .736-.274l43.443 1.576a1.003 1.003 0 0 1 .974.994v59.541ZM104.268 139.708l6.09 32.995-6.09-32.995ZM186.909 174.026ZM112.789 174.725Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M251.411 73.276V13.472l-1.801-.066a1.018 1.018 0 0 0-.739.282 1.006 1.006 0 0 0-.31.727v61.77a1.006 1.006 0 0 0 1.002 1.008l43.444.394a1.008 1.008 0 0 0 1.02-1.009v-1.937l-41.614-.37a1.006 1.006 0 0 1-1.002-.994v-.001Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M251.411 73.276V13.472l-1.801-.066a1.018 1.018 0 0 0-.739.282 1.006 1.006 0 0 0-.31.727v61.77a1.006 1.006 0 0 0 1.002 1.008l43.444.394a1.008 1.008 0 0 0 1.02-1.009v-1.937l-41.614-.37a1.006 1.006 0 0 1-1.002-.994v-.001Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m295.903 13.13-43.443-1.577a1.005 1.005 0 0 0-1.049.995v60.728a1.002 1.002 0 0 0 1.002.994l41.614.37h1.829a1.005 1.005 0 0 0 .94-.605c.052-.121.079-.252.081-.384V14.11a1.003 1.003 0 0 0-.974-.98ZM291.2 68.05v-.06l-33.168-.315a.794.794 0 0 1-.766-.812v-49.23h-.075l.042-1.14h.654c.06-.01.122-.01.183 0l2.046.08 31.978.886.099 50.493-.993.098Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M258.06 16.493a.573.573 0 0 0-.183 0l2.229.061-2.046-.06Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M257.238 17.633v49.23a.794.794 0 0 0 .766.811l33.168.315-.244-49.122-33.69-1.234Zm26.579 36.715-.061.042a1.13 1.13 0 0 1-.672.22 1.139 1.139 0 0 1-.941-.468 1.148 1.148 0 0 1-.209-.852 1.13 1.13 0 0 1 .458-.748l.08-.056a7.41 7.41 0 0 0 3.292-6.21 7.851 7.851 0 0 0-.042-.826h-20.377a4.312 4.312 0 0 1-3.98-2.653 4.297 4.297 0 0 1-.328-1.644v-4.255a.213.213 0 0 1 .212-.206l2.502 1.562h.07c.366-.141.756-.21 1.148-.202a2.91 2.91 0 0 1 1.237.244h.131l2.243-1.609a.21.21 0 0 1 .148.06c.04.039.063.091.064.147v3.377c1.707-2.59 4.947-4.34 8.662-4.34 3.871 0 7.224 1.877 8.87 4.692l.037.047a10.475 10.475 0 0 1 1.675 5.629 9.734 9.734 0 0 1-4.2 8.05h-.019Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M257.877 16.512h-.654l-.042 1.14h.075v-.329a.802.802 0 0 1 .621-.811Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "M257.877 16.512h-.654l-.042 1.14h.075v-.329a.802.802 0 0 1 .621-.811Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m260.106 16.573 31.156 1.205a.8.8 0 0 1 .743.812v48.588a.79.79 0 0 1-.781.811h-.033v.061l.974-.098-.099-50.492-31.96-.887Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m260.106 16.573 31.156 1.205a.8.8 0 0 1 .743.812v48.588a.79.79 0 0 1-.781.811h-.033v.061l.974-.098-.099-50.492-31.96-.887Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M292.005 67.178V18.59a.798.798 0 0 0-.743-.812l-31.156-1.205-2.229-.061a.805.805 0 0 0-.639.811v.329l33.69 1.233.244 49.123h.033a.792.792 0 0 0 .752-.513.795.795 0 0 0 .048-.317Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "M292.005 67.178V18.59a.798.798 0 0 0-.743-.812l-31.156-1.205-2.229-.061a.805.805 0 0 0-.639.811v.329l33.69 1.233.244 49.123h.033a.792.792 0 0 0 .752-.513.795.795 0 0 0 .048-.317Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M286.395 40.613c-1.646-2.772-4.999-4.69-8.87-4.69-3.715 0-6.955 1.75-8.662 4.339v-3.378a.208.208 0 0 0-.064-.146.21.21 0 0 0-.148-.06l-2.243 1.609h-.132a2.903 2.903 0 0 0-1.236-.244 3.03 3.03 0 0 0-1.148.202h-.07l-2.502-1.563a.21.21 0 0 0-.148.06.208.208 0 0 0-.064.147v4.255a4.297 4.297 0 0 0 4.308 4.296h20.377c.028.275.042.55.042.826a7.41 7.41 0 0 1-3.292 6.21l-.08.057a1.132 1.132 0 0 0-.459.748 1.14 1.14 0 0 0 .21.851 1.133 1.133 0 0 0 .94.47c.242 0 .478-.077.673-.221l.061-.042a9.728 9.728 0 0 0 4.232-8.064 10.465 10.465 0 0 0-1.674-5.629l-.051-.033Zm-18.811 1.408 1.255-3.12.024 1.407-1.279 1.713Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m267.556 42.035 1.279-1.722-.024-1.398-1.255 3.12ZM176.737 9.227V.005h-.029v9.49c.015-.09.024-.179.029-.268Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M152.617 1.876C154.817.652 156.877 0 158.97.54c4.42 1.112 4.571 6.263 10.252 11.606h4.59c.32-.002.638-.057.94-.165a2.27 2.27 0 0 1-.404.043V.005h-23.391c.127.14.244.276.376.417.423.507.856.985 1.284 1.454Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129.023 12.093a3.279 3.279 0 0 1-2.398-3.162V.02h-.038V9.24a2.916 2.916 0 0 0 2.436 2.852Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129.512 15.84h44.3a6.65 6.65 0 0 0 4.686-1.939 6.612 6.612 0 0 0 1.944-4.674V.005h-3.705v9.222c-.005.09-.014.179-.028.267v.155a2.352 2.352 0 0 1-1.98 2.345c-.302.108-.62.163-.941.165h-4.59l.094.093h-39.375a3.303 3.303 0 0 1-.941-.145 2.93 2.93 0 0 1-1.742-.99 2.914 2.914 0 0 1-.694-1.876V.019h-3.706V9.24a6.616 6.616 0 0 0 1.967 4.682 6.644 6.644 0 0 0 4.711 1.918Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M174.729 11.98a2.91 2.91 0 0 0 1.98-2.486V.004h-2.385v12.019a2.29 2.29 0 0 0 .405-.043Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M174.729 11.98a2.91 2.91 0 0 0 1.98-2.486V.004h-2.385v12.019a2.29 2.29 0 0 0 .405-.043Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M174.729 11.98a2.351 2.351 0 0 0 1.98-2.345V9.48a2.9 2.9 0 0 1-1.98 2.5Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M174.729 11.98a2.351 2.351 0 0 0 1.98-2.345V9.48a2.9 2.9 0 0 1-1.98 2.5Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129.023 12.093c.155.03.312.048.47.052h10.99a32.849 32.849 0 0 1 7.219-7.037 54.778 54.778 0 0 1 4.896-3.236c-.428-.47-.861-.939-1.308-1.455-.131-.14-.249-.276-.376-.417h-24.308v8.913a3.272 3.272 0 0 0 .668 1.998c.437.575 1.052.99 1.749 1.182Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129.023 12.093c.155.03.312.048.47.052h10.99a32.849 32.849 0 0 1 7.219-7.037 54.778 54.778 0 0 1 4.896-3.236c-.428-.47-.861-.939-1.308-1.455-.131-.14-.249-.276-.376-.417h-24.308v8.913a3.272 3.272 0 0 0 .668 1.998c.437.575 1.052.99 1.749 1.182Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M129.512 12.163a2.82 2.82 0 0 1-.47-.051c.305.094.622.142.941.145h10.491l.071-.094h-11.033Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "M129.512 12.163a2.82 2.82 0 0 1-.47-.051c.305.094.622.142.941.145h10.491l.071-.094h-11.033Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M158.951.54c-2.092-.526-4.152.112-6.353 1.336a54.779 54.779 0 0 0-4.896 3.237 32.865 32.865 0 0 0-7.218 7.036h28.719c-5.662-5.347-5.812-10.498-10.252-11.61Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M158.951.54c-2.092-.526-4.152.112-6.353 1.336a54.779 54.779 0 0 0-4.896 3.237 32.865 32.865 0 0 0-7.218 7.036h28.719c-5.662-5.347-5.812-10.498-10.252-11.61Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color20)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M140.432 12.239h28.865l-.094-.094h-28.719l-.052.094Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "M140.432 12.239h28.865l-.094-.094h-28.719l-.052.094Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M35.938 49.367V.005h-.029v49.629c.015-.089.024-.178.029-.267Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.93 52.12c-.132.026-.266.04-.4.042V.005H14.465C11.645 0 8.886.825 6.532 2.374c.08 0 .155-.033.24-.043a3.37 3.37 0 0 1 3.292 1.61c.231-.411.5-.799.804-1.16C12.5.86 14.696.039 15.778.953c1.081.915.64 3.209-.993 5.132a6.223 6.223 0 0 1-3.165 2.12c.155.793.278 1.642.377 2.524.338 3.087.536 6.44-.306 8.533h1.773c-.23-.938 0-2.163.122-3.542.226-2.814 1.336-5.07 2.982-5.108 3.014-.07 2.976 2.284 2.976 5.108a7.275 7.275 0 0 1-.841 3.542h4.843v6.802h-1.34v13.716H0V52.26h32.994c.318.006.634-.042.936-.14Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.461 11.76c-.305-2.768-.353-5.282.301-7.036A14.325 14.325 0 0 0 0 14.4v4.846h4.98c-1.03-1.802-1.218-4.593-1.519-7.487Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M39.644 49.367V.005h-3.706v49.362c-.005.09-.014.178-.028.267v.15a2.365 2.365 0 0 1-1.98 2.346c-.302.107-.62.163-.94.164H0v3.696h32.994a6.65 6.65 0 0 0 4.703-1.935 6.619 6.619 0 0 0 1.947-4.688Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.93 52.12a2.901 2.901 0 0 0 1.98-2.486V.004h-2.38v52.158c.134-.002.268-.016.4-.042Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.93 52.12a2.901 2.901 0 0 0 1.98-2.486V.004h-2.38v52.158c.134-.002.268-.016.4-.042Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M33.93 52.12a2.365 2.365 0 0 0 1.98-2.345v-.15a2.89 2.89 0 0 1-1.98 2.495Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".2",
    d: "M33.93 52.12a2.365 2.365 0 0 0 1.98-2.345v-.15a2.89 2.89 0 0 1-1.98 2.495Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.23 26.086h-.015v1.52H.02v12.196h22.21V26.086Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M22.215 26.325v-.249a.943.943 0 0 0-.24 0H.26a.239.239 0 0 0-.24.244v1.06a.24.24 0 0 0 .24.24h21.717a.24.24 0 0 0 .24-.24v-1.055Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.556 26.062v-6.801H0v6.801h23.556Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.461 11.76c.315 2.894.47 5.685 1.538 7.505h6.682c.842-2.092.645-5.446.306-8.532a31.527 31.527 0 0 0-.376-2.524 6.222 6.222 0 0 0 3.165-2.12c1.632-1.923 2.074-4.222.992-5.132-1.082-.91-3.292-.094-4.91 1.83-.303.36-.572.748-.804 1.158a3.36 3.36 0 0 0-3.292-1.609c-.084 0-.16.028-.24.042a14.499 14.499 0 0 0-2.77 2.346c-.644 1.754-.597 4.268-.29 7.036ZM18.702 19.284c.577-1.09.866-2.309.842-3.541 0-2.815.038-5.16-2.977-5.109-1.646.038-2.755 2.294-2.981 5.108-.113 1.38-.353 2.623-.123 3.542h5.24Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M112.79 191.208a5.565 5.565 0 0 1 .841-3.03h-7.557a2.47 2.47 0 0 1-2.248-1.445H34.461c-1.19 0-2.33.472-3.172 1.311a4.47 4.47 0 0 0-1.314 3.164v6.286c.006.682.167 1.354.47 1.966h82.683a5.978 5.978 0 0 1-.324-1.966l-.014-6.286Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M65.504 137.226a1.051 1.051 0 0 1-1.072-1.008l-1.533-62.389h-1.882a1.055 1.055 0 0 0-1.067 1.08l1.585 64.428a1.054 1.054 0 0 0 1.072 1.027l32.275-.497-.654-3.072-28.724.431Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M65.504 137.226a1.051 1.051 0 0 1-1.072-1.008l-1.533-62.389h-1.882a1.055 1.055 0 0 0-1.067 1.08l1.585 64.428a1.054 1.054 0 0 0 1.072 1.027l32.275-.497-.654-3.072-28.724.431Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m103.699 136.63.569 3.078-.569-3.078Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m103.699 136.63.569 3.078-.569-3.078Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m65.504 137.226 28.724-.446-1.463-6.9-21.58.324a.822.822 0 0 1-.818-.826L69.1 78.028h-.08V76.84h.682a.863.863 0 0 1 .188-.024l2.14.033 33.361.103.908 34.244h4.956l-.94-37.846a1.041 1.041 0 0 0-1.044-1.009l-45.353-.534a1.046 1.046 0 0 0-.991.65c-.053.13-.08.27-.076.41v.966l1.533 62.388a1.038 1.038 0 0 0 .346.738c.105.094.227.166.36.211.132.046.273.065.413.055Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M69.905 76.817a.863.863 0 0 0-.188.024h2.352l-2.164-.024ZM103.172 126.437ZM103.878 126.057ZM102.26 128.834l.169.901-.169-.901Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m69.102 78.028 1.265 51.35a.822.822 0 0 0 .818.826l21.58-.324-2.11-9.93c-1.412.211-2.54 0-2.583-1.051 0-.403-.051-.98-.108-1.844a4.64 4.64 0 0 1-1.994.47c-4.289 0-7.769-4.926-7.769-11.001 0-2.5-.066-4.803.424-6.647-1.52.418-2.977-.032-3.32-1.06-.255-.769.178-1.65 1.03-2.289h-1.016a1.083 1.083 0 0 1-1.082-1.079c0-.913.364-1.788 1.011-2.434a3.456 3.456 0 0 1 2.44-1.009h1.929a5.993 5.993 0 0 1 4.514-2.674l3.335-.276a10.147 10.147 0 0 1 8.447 3.4 10.075 10.075 0 0 1 2.289 8.795l-1.576 8.126a.706.706 0 0 1-.362.469c.16.389.339.806.546 1.318h8.432l-.969-32.747-35.171-.39Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M69.717 76.84h-.681v1.188h.08v-.343a.834.834 0 0 1 .601-.844Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "M69.717 76.84h-.681v1.188h.08v-.343a.834.834 0 0 1 .601-.844Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m72.045 76.85 32.529.47a.834.834 0 0 1 .799.825l.814 33.066h.127l-.908-34.243-33.36-.118Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m72.045 76.85 32.529.47a.834.834 0 0 1 .799.825l.814 33.066h.127l-.908-34.243-33.36-.118Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m104.574 77.31-32.529-.47h-2.351a.837.837 0 0 0-.626.845v.343l35.172.426.969 32.747h.94l-.813-33.066a.836.836 0 0 0-.762-.825Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m104.574 77.31-32.529-.47h-2.351a.837.837 0 0 0-.626.845v.343l35.172.426.969 32.747h.94l-.813-33.066a.836.836 0 0 0-.762-.825Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m96.626 109.395 1.575-8.124a10.076 10.076 0 0 0-2.288-8.796 10.147 10.147 0 0 0-8.448-3.4l-3.334.276a6.011 6.011 0 0 0-4.515 2.674h-1.928c-.915 0-1.793.363-2.44 1.009a3.438 3.438 0 0 0-1.011 2.434 1.077 1.077 0 0 0 1.081 1.08h1.016c-.851.637-1.284 1.519-1.03 2.288.343 1.028 1.801 1.478 3.32 1.06-.47 1.844-.423 4.147-.423 6.647 0 6.075 3.48 11 7.769 11a4.64 4.64 0 0 0 1.994-.469c.056.863.094 1.44.108 1.844.042 1.069 1.194 1.262 2.582 1.05l-1.223-5.765a2.458 2.458 0 0 1 .496-2.068 2.47 2.47 0 0 1 1.926-.915h4.956a101.14 101.14 0 0 0-.545-1.318.702.702 0 0 0 .362-.507Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m96.626 109.395 1.575-8.124a10.076 10.076 0 0 0-2.288-8.796 10.147 10.147 0 0 0-8.448-3.4l-3.334.276a6.011 6.011 0 0 0-4.515 2.674h-1.928c-.915 0-1.793.363-2.44 1.009a3.438 3.438 0 0 0-1.011 2.434 1.077 1.077 0 0 0 1.081 1.08h1.016c-.851.637-1.284 1.519-1.03 2.288.343 1.028 1.801 1.478 3.32 1.06-.47 1.844-.423 4.147-.423 6.647 0 6.075 3.48 11 7.769 11a4.64 4.64 0 0 0 1.994-.469c.056.863.094 1.44.108 1.844.042 1.069 1.194 1.262 2.582 1.05l-1.223-5.765a2.458 2.458 0 0 1 .496-2.068 2.47 2.47 0 0 1 1.926-.915h4.956a101.14 101.14 0 0 0-.545-1.318.702.702 0 0 0 .362-.507Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M144.744 132.624a16.676 16.676 0 0 0-6.785 1.337 16.625 16.625 0 0 0-5.654 3.973 16.696 16.696 0 0 0-4.232 12.928c.889 10.105 9.847 18.328 19.977 18.328a16.675 16.675 0 0 0 12.443-5.315 16.698 16.698 0 0 0 4.233-12.928c-.889-10.104-9.852-18.323-19.982-18.323Zm3.014 34.145c-8.676 0-16.403-7.083-17.16-15.742-.757-8.66 5.719-15.743 14.4-15.743 8.681 0 16.403 7.083 17.165 15.743.762 8.659-5.723 15.742-14.405 15.742Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m148.605 151.013 3.292-3.622a1.532 1.532 0 0 0-.193-2.204 1.52 1.52 0 0 0-1.105-.472 1.535 1.535 0 0 0-1.105.472l-3.292 3.621-3.95-3.621a1.531 1.531 0 0 0-2.21 0 1.526 1.526 0 0 0-.196 1.732c.098.182.231.343.393.472l3.946 3.622-3.292 3.621a1.533 1.533 0 0 0-.2 1.732c.098.182.231.343.393.473a1.514 1.514 0 0 0 1.102.471 1.523 1.523 0 0 0 1.103-.471l3.292-3.622 3.946 3.622a1.531 1.531 0 0 0 2.21 0 1.535 1.535 0 0 0-.193-2.205l-3.941-3.621Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M312.452 191.208c0-2.472-1.411-4.475-3.17-4.475h-65.179a2.132 2.132 0 0 1-2.022 1.445h-128.45a5.575 5.575 0 0 0-.842 3.03v6.286a6.005 6.005 0 0 0 .325 1.966h194.442a7.953 7.953 0 0 0 4.901-1.769v-.192l-.005-6.291Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m212.303 179.186-12.8-65.982a2.475 2.475 0 0 0-2.436-2.003H91.853a2.489 2.489 0 0 0-1.925.915 2.463 2.463 0 0 0-.497 2.069l1.223 5.765 2.111 9.93 1.463 6.901.654 3.072 8.563 40.313c.117.555.421 1.052.862 1.409a2.48 2.48 0 0 0 1.56.552h104.005a2.472 2.472 0 0 0 1.91-.899 2.474 2.474 0 0 0 .521-2.042Zm-16.252-22.61h-11.348l2.906 15.222a2.43 2.43 0 0 1-.47 1.956 2.135 2.135 0 0 1-.23.272 2.481 2.481 0 0 1-1.726.699h-72.394a2.45 2.45 0 0 1-1.048-.235 2.464 2.464 0 0 1-1.383-1.787l-6.113-32.995-.569-3.078-1.27-6.895-.169-.901a2.477 2.477 0 0 1 .047-1.097c.038-.145.092-.285.16-.418l.084-.164c.117-.199.259-.382.423-.544.062-.061.132-.118.198-.174.214-.163.452-.291.705-.38.264-.094.543-.14.823-.136h6.974l45.57.16-.852-4.494a2.499 2.499 0 0 1 2.455-2.951h30.972a2.5 2.5 0 0 1 1.593.574c.448.371.751.887.857 1.457l6.231 32.935a2.488 2.488 0 0 1-.51 2.057 2.494 2.494 0 0 1-1.916.917Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color2)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M106.074 188.178h34.574a4.006 4.006 0 0 1-3.292-1.698l-3.066-4.353h-28.216a2.471 2.471 0 0 0-2.478 2.472v1.107c.001.355.079.706.23 1.027a2.466 2.466 0 0 0 2.248 1.445Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color13)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M137.375 186.48a4.006 4.006 0 0 0 3.292 1.698H242.1a2.14 2.14 0 0 0 2.022-1.445c.08-.224.123-.46.127-.698v-3.908h-109.94l3.066 4.353ZM192.27 120.691a2.494 2.494 0 0 0-2.45-2.031h-30.972a2.498 2.498 0 0 0-2.418 1.866 2.48 2.48 0 0 0-.037 1.084l.851 4.494 19.61.066c.133.001.265.013.395.037a2.463 2.463 0 0 1 2.027 1.966l5.427 28.403h11.348a2.493 2.493 0 0 0 2.415-1.867c.091-.354.103-.724.035-1.084l-6.231-32.934Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M177.249 126.207a2.175 2.175 0 0 0-.395-.037l-19.61-.066-45.569-.159h-6.974a2.45 2.45 0 0 0-.823.136 2.537 2.537 0 0 0-.706.38c-.065.056-.136.112-.197.173a2.623 2.623 0 0 0-.423.544l-.085.165a2.15 2.15 0 0 0-.16.417 2.55 2.55 0 0 0-.085.535c-.008.188.005.377.038.563l.169.9 1.27 6.896.569 3.077 6.114 32.996c.024.144.063.285.117.422.099.268.245.516.433.731a2.44 2.44 0 0 0 1.077.732c.258.091.53.137.804.136h72.393c.645 0 1.264-.25 1.726-.699.084-.084.162-.175.231-.272a2.434 2.434 0 0 0 .47-1.956l-2.906-15.222-5.427-28.403a2.468 2.468 0 0 0-2.051-1.989Zm-16.055 38.325a17.61 17.61 0 0 1-13.167 5.629c-10.619 0-20.015-8.622-20.946-19.233a17.643 17.643 0 0 1 4.496-13.664 17.6 17.6 0 0 1 13.167-5.629c10.624 0 20.02 8.617 20.946 19.232a17.617 17.617 0 0 1-.79 7.309 17.65 17.65 0 0 1-3.706 6.356Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M144.998 135.284c-8.681 0-15.161 7.083-14.4 15.743.762 8.659 8.465 15.742 17.161 15.742 8.695 0 15.161-7.083 14.404-15.742-.757-8.66-8.484-15.743-17.165-15.743Zm7.731 21.578a1.52 1.52 0 0 1-1.105.472 1.535 1.535 0 0 1-1.105-.472l-3.945-3.621-3.292 3.621a1.534 1.534 0 0 1-1.103.471 1.53 1.53 0 0 1-1.103-.471 1.53 1.53 0 0 1-.497-1.671c.064-.197.168-.378.304-.534l3.292-3.621-3.945-3.621a1.529 1.529 0 0 1-.198-2.205 1.531 1.531 0 0 1 2.21 0l3.951 3.621 3.292-3.621a1.52 1.52 0 0 1 1.105-.471 1.534 1.534 0 0 1 1.105.471 1.538 1.538 0 0 1 .193 2.205l-3.292 3.621 3.945 3.621a1.528 1.528 0 0 1 .49 1.665 1.526 1.526 0 0 1-.302.531v.009Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color11)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M144.744 131.653a17.625 17.625 0 0 0-13.168 5.629 17.662 17.662 0 0 0-3.705 6.356 17.617 17.617 0 0 0-.79 7.309c.94 10.592 10.346 19.232 20.946 19.232a17.633 17.633 0 0 0 13.167-5.629 17.64 17.64 0 0 0 4.496-13.669c-.927-10.611-10.323-19.228-20.946-19.228Zm15.735 32.222a16.675 16.675 0 0 1-12.443 5.315c-10.13 0-19.088-8.223-19.977-18.328-.242-2.33.01-4.685.739-6.912a16.752 16.752 0 0 1 3.493-6.016 16.642 16.642 0 0 1 12.439-5.31c10.13 0 19.093 8.219 19.977 18.323a16.695 16.695 0 0 1-4.228 12.928Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }));
};
SceneErrorScreen.defaultProps = {
  width: "320",
  height: "200",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Scene-ErrorScreen"
};
var SpotErrorScreen = function SpotErrorScreen(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("path", {
    d: "m72.016 127.769.427-.056H55.55l.427.056h16.04ZM73 53.991l19.014.067-19.013-.067-44.237-.155 44.237.155Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M111.614 39.512a2.403 2.403 0 0 1 2.357 1.947l9.171 47.323A63.743 63.743 0 0 0 128 64.295a63.95 63.95 0 0 0-18.749-45.233A63.994 63.994 0 0 0 63.998.331a63.708 63.708 0 0 0-36.26 11.245l.705 27.936h83.171ZM23.384 108.431h-.2a2.405 2.405 0 0 1-2.35-1.904l-8.297-39.175-12.453.194a63.817 63.817 0 0 0 20.898 44.115v-.829a2.405 2.405 0 0 1 2.402-2.401ZM100.086 101.237H29.893a2.4 2.4 0 0 1-2.356-1.964L21.635 67.21l5.902 32.062a2.4 2.4 0 0 0 2.356 1.964h70.2a2.398 2.398 0 0 0-.007 0Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M103.902 114.309H24.097a63.693 63.693 0 0 0 31.452 13.4h16.894a63.684 63.684 0 0 0 31.459-13.4Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m11.899 64.366-11.895.187c0 1.001.025 1.999.077 2.993l12.453-.194-.635-2.986Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m11.899 64.366-11.895.187c0 1.001.025 1.999.077 2.993l12.453-.194-.635-2.986Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color19)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m10.48 57.662-10.155.155A64.444 64.444 0 0 0 0 64.295v.257l11.895-.186-1.414-6.704ZM28.411 39.512l-.688-27.936a62.449 62.449 0 0 0-4.762 3.618l.646 24.332 4.804-.014Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m15.75 29.86-1.527 7.896a.679.679 0 0 1-.353.472c.156.381.329.79.53 1.284h8.177l-.706-23.39a64.191 64.191 0 0 0-7.002 7.155 9.712 9.712 0 0 1 .882 6.583Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M21.113 54.005ZM19.688 56.643l.162.882-.162-.882Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.434 48.014c-1.348.201-2.47 0-2.505-1.023 0-.391-.05-.952-.106-1.791a4.444 4.444 0 0 1-1.93.451 5.393 5.393 0 0 1-1.096-.116 63.43 63.43 0 0 0-2.47 12.282l10.156-.155-2.05-9.648Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color7)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M23.004 53.818h-.942.942ZM23.621 39.512l-.646-24.332-.077.064.596 24.254.127.014Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m23.621 39.512-.646-24.332-.077.064.596 24.254.127.014Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m23.494 39.512-.596-24.254a30.66 30.66 0 0 0-1.01.864l.706 23.39h.9Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    opacity: ".5",
    d: "m23.494 39.512-.596-24.254a30.66 30.66 0 0 0-1.01.864l.706 23.39h.9Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.835 45.2c.056.84.091 1.41.106 1.791.042 1.037 1.157 1.224 2.504 1.023l-1.2-5.603a2.404 2.404 0 0 1 2.354-2.9h4.804c-.2-.493-.374-.902-.529-1.283a.681.681 0 0 0 .353-.472l1.527-7.896a9.712 9.712 0 0 0-.864-6.583A63.848 63.848 0 0 0 2.801 45.535c.36.076.728.115 1.097.116a4.442 4.442 0 0 0 1.937-.451Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M5.835 45.2c.056.84.091 1.41.106 1.791.042 1.037 1.157 1.224 2.504 1.023l-1.2-5.603a2.404 2.404 0 0 1 2.354-2.9h4.804c-.2-.493-.374-.902-.529-1.283a.681.681 0 0 0 .353-.472l1.527-7.896a9.712 9.712 0 0 0-.864-6.583A63.848 63.848 0 0 0 2.801 45.535c.36.076.728.115 1.097.116a4.442 4.442 0 0 0 1.937-.451Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color18)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M111.614 39.512H9.599a2.407 2.407 0 0 0-2.353 2.898l1.189 5.604 2.046 9.648 1.41 6.7.636 2.987 8.3 39.174a2.4 2.4 0 0 0 2.35 1.904h87.132a64.033 64.033 0 0 0 12.812-19.649l-9.172-47.323a2.403 2.403 0 0 0-2.335-1.943Zm-.991 44.08H99.62l2.822 14.789a2.38 2.38 0 0 1-.141 1.364 2.39 2.39 0 0 1-2.215 1.481H29.893a2.394 2.394 0 0 1-2.356-1.964l-5.902-32.061-.55-2.99-1.235-6.7-.162-.882a2.47 2.47 0 0 1 0-.787 2.475 2.475 0 0 1 .377-.98 2.426 2.426 0 0 1 1.454-1.001c.179-.044.362-.064.546-.06h6.72l44.226.155-.825-4.362a2.418 2.418 0 0 1 2.377-2.867h30.031a2.416 2.416 0 0 1 2.378 1.968L113 80.73a2.413 2.413 0 0 1-1.346 2.642 2.42 2.42 0 0 1-1.031.229v-.01Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color2)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m53.736 112.662-2.973-4.231H23.385a2.407 2.407 0 0 0-2.406 2.401v.829c1.009.917 2.048 1.8 3.118 2.648h32.807a3.886 3.886 0 0 1-3.168-1.647Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color13)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M53.736 112.662a3.874 3.874 0 0 0 3.175 1.647h46.991a64.34 64.34 0 0 0 6.428-5.878H50.762l2.974 4.231ZM106.961 48.73a2.414 2.414 0 0 0-2.378-1.968h-30.03a2.42 2.42 0 0 0-2.378 2.867l.826 4.362 19.013.067c.128.001.256.013.381.035a2.396 2.396 0 0 1 1.965 1.912l5.26 27.597h11.003A2.415 2.415 0 0 0 113 80.735l-6.039-32.005Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color14)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "m64.608 78.21 3.21-3.526a1.487 1.487 0 0 0-.186-2.14 1.474 1.474 0 0 0-2.142 0l-3.213 3.526-3.828-3.527a1.474 1.474 0 0 0-2.141 0 1.487 1.487 0 0 0 .187 2.14l3.827 3.527-3.21 3.526a1.49 1.49 0 0 0 .187 2.144 1.48 1.48 0 0 0 2.142 0l3.213-3.526 3.828 3.526a1.478 1.478 0 0 0 2.14 0 1.496 1.496 0 0 0-.186-2.144l-3.828-3.526Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.865 60.328a16.126 16.126 0 0 0-12.06 5.162c-3.07 3.35-4.53 7.811-4.117 12.561.86 9.818 9.55 17.805 19.37 17.805a16.122 16.122 0 0 0 12.06-5.163c3.07-3.35 4.534-7.807 4.118-12.56-.847-9.818-9.535-17.805-19.37-17.805Zm2.925 33.18c-8.417 0-15.906-6.884-16.64-15.298s5.546-15.297 13.962-15.297c8.417 0 15.903 6.883 16.64 15.297.738 8.414-5.531 15.297-13.948 15.297h-.014Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M94.378 56.005a2.395 2.395 0 0 0-1.965-1.912 2.244 2.244 0 0 0-.38-.035l-19.015-.067-44.254-.155h-6.702a2.146 2.146 0 0 0-.547.06 2.426 2.426 0 0 0-1.453 1.002 2.47 2.47 0 0 0-.377.98 2.47 2.47 0 0 0 0 .786l.161.882 1.235 6.7.55 2.99 5.902 32.062a2.4 2.4 0 0 0 2.357 1.964h70.199a2.402 2.402 0 0 0 2.216-1.481 2.38 2.38 0 0 0 .141-1.365l-2.822-14.79-5.246-27.621ZM76.849 91.332A17.06 17.06 0 0 1 64.09 96.8c-10.296 0-19.401-8.375-20.308-18.669-.44-5.017 1.108-9.732 4.36-13.28a17.053 17.053 0 0 1 12.725-5.47c10.297 0 19.401 8.376 20.308 18.67.455 5.017-1.094 9.732-4.342 13.28h.017Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color8)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M61.127 62.913c-8.417 0-14.7 6.883-13.963 15.297.738 8.414 8.223 15.297 16.64 15.297s14.7-6.883 13.962-15.297c-.737-8.414-8.222-15.297-16.64-15.297Zm7.5 20.957a1.478 1.478 0 0 1-2.142 0l-3.827-3.526-3.214 3.526a1.478 1.478 0 0 1-2.141 0 1.493 1.493 0 0 1-.187-2.144l3.21-3.526-3.828-3.527a1.487 1.487 0 0 1-.186-2.14 1.474 1.474 0 0 1 2.14 0l3.828 3.526 3.214-3.526a1.474 1.474 0 0 1 2.141 0 1.487 1.487 0 0 1 .187 2.14l-3.21 3.526 3.828 3.527a1.496 1.496 0 0 1 .186 2.144Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color11)"
    }
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M60.865 59.383a17.058 17.058 0 0 0-12.741 5.48c-3.253 3.547-4.801 8.262-4.36 13.28.9 10.293 10.011 18.668 20.308 18.668a17.064 17.064 0 0 0 12.76-5.469c3.249-3.547 4.797-8.262 4.356-13.28-.9-10.304-10.011-18.68-20.323-18.68Zm15.254 31.31a16.118 16.118 0 0 1-12.061 5.163c-9.82 0-18.51-7.987-19.37-17.805-.413-4.75 1.058-9.21 4.117-12.56a16.12 16.12 0 0 1 12.06-5.163c9.821 0 18.51 7.987 19.37 17.804.431 4.754-1.026 9.211-4.102 12.561h-.014Z",
    style: {
      fill: "var(--sapContent_Illustrative_Color3)"
    }
  }));
};
SpotErrorScreen.defaultProps = {
  width: "128",
  height: "128",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  id: "sapIllus-Spot-ErrorScreen"
};
var illustrationImports = {
  DialogErrorScreen: DialogErrorScreen,
  DotErrorScreen: DotErrorScreen,
  SceneErrorScreen: SceneErrorScreen,
  SpotErrorScreen: SpotErrorScreen
};
/** **Illustration**s are design recommendations for empty states. They include an illustration
 * paired with a message that, together, communicate what the user would see if they had data,
 * while providing constructive guidance about next steps.
 * They serve to add clarity and to humanize the experience users have with SAP products.
 *
 * Use with
 * [**IllustrationMessage**](./?path=/docs/components-alerts-messaging-illustratedmessage--docs)
 * to provide a complete message.
 *
 * To request additional illustrations, contact #ask-core-ui.
 *
 * For instructions on which illustration to use for a given scenarios, contact #ask-ux-design-systems. */
var ErrorScreen = exports.ErrorScreen = function ErrorScreen(props) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var _a = addChildProps ? (0, _assign.default)((0, _assign.default)({}, props), addChildProps(ErrorScreen, props)) : props,
    _a$size = _a.size,
    size = _a$size === void 0 ? 'md' : _a$size,
    useResponsiveSizing = _a.useResponsiveSizing,
    containerRef = _a.containerRef,
    otherProps = __rest(_a, ["size", "useResponsiveSizing", "containerRef"]);
  var variant = 'Dialog';
  var windowSize = (0, _useWindowSize.default)();
  var _useResizeObserver = (0, _useResizeObserver2.default)({
      targetRef: containerRef
    }),
    containerWidth = _useResizeObserver.width,
    containerHeight = _useResizeObserver.height;
  if (size === 'lg') {
    variant = 'Scene';
  } else if (size === 'sm') {
    variant = 'Spot';
  } else if (size === 'xs') {
    variant = 'Dot';
  }
  var width = containerWidth || windowSize.width;
  var height = containerHeight || windowSize.height;
  if (useResponsiveSizing) {
    if (width <= 260 || height <= 207) {
      variant = 'Dot';
    } else if (width <= 360 || height <= 284) {
      variant = 'Spot';
    } else if (width <= 681 || height <= 415) {
      variant = 'Dialog';
    } else {
      variant = 'Scene';
    }
  }
  var importName = "".concat(variant, "ErrorScreen");
  return /*#__PURE__*/_react.default.createElement(_Illustration.default, (0, _assign.default)({}, otherProps, {
    variant: variant,
    screenReaderOnly: useResponsiveSizing && (width <= 160 || height <= 61),
    Component: illustrationImports[importName]
  }));
};
ErrorScreen.displayName = 'ErrorScreen';
var _default = exports.default = ErrorScreen;